import React from "react";
import {renderRichText} from "gatsby-source-contentful/rich-text";
import {getImage} from "../../contentful/data-provider";

export default function RowOfPostElement({content}) {
    const renderExcerpt = () => {
        if (content.preview) {
            return renderRichText(content.preview)
        }

        if (content.excerpt) {
            return renderRichText(content.excerpt)
        }

        if (content.body) {
            return renderRichText(content.body)
        }

        return '';
    }

    return (
        <div key={content.id} className={'ecosystem-box'}>
            <a href={content.slug ? '/blog/' + content.category?.slug + '/' + content.slug : content.ctaUrl} target={(content.openOnNewPage || !content.slug) ? '_blank' : '_self'} rel={'noreferrer'} className={'text-decoration-none'}>
                <div className="blogbox past">
                    <div className="blogbox--header">
                        <div className="img-container">
                            <img src={getImage(content.image).url}
                                 className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                 alt={getImage(content.image).title}/>
                        </div>
                    </div>
                    <div className="blogbox--content">
                        { content.publishedAt && <span className={'date'}>{content.publishedAt}</span>}
                        <h3>{content.title}</h3>
                        <div className="blogbox--content__inner">
                            { renderExcerpt() }
                        </div>
                        { (content.ctaText || content.slug) &&
                            <div className="btn-container">
                                <div className={`more`}>
                                    <i className="fas fa-arrow-right"/>
                                    {content.slug ? 'Read Article' : content.ctaText}
                                </div>
                            </div>
                        }
                        { content.tags &&
                            <div className="tag-container">
                                { content.tags.split(',').map((tag, index) => {
                                        return (
                                            <span className="tag" key={index}>{tag.trim()}</span>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                </div>
            </a>
        </div>
    )
}
